import { createStitches as r } from "../node_modules/@stitches/core/dist/index.es.js";
import * as i from "../utils/themeUtils.es.js";
const e = {
  utils: i,
  media: {
    xs: "(min-width: 300px)",
    sm: "(min-width: 600px)",
    md: "(min-width: 900px)",
    lg: "(min-width: 1200px)",
    xl: "(min-width: 1536px)",
    "max-xs": "(max-width: 300px)",
    "max-sm": "(max-width: 600px)",
    "max-md": "(max-width: 900px)",
    "max-lg": "(max-width: 1200px)",
    "max-xl": "(max-width: 1536px)"
  },
  theme: {
    sizes: {
      sm: "4px",
      md: "8px",
      lg: "12px",
      xl: "20px"
    },
    colors: {
      // Clubspark/Draws specific tokens
      csHiContrast: "hsl(206,10%,5%)",
      csLoContrast: "white",
      csBackground: "#fff",
      csGray100: "hsl(206,22%,99%)",
      csGray200: "hsl(206,12%,97%)",
      csGray300: "hsl(206,11%,92%)",
      csGray400: "hsl(206,10%,84%)",
      csGray500: "hsl(206,10%,76%)",
      csGray550: "hsl(206,10%,60%)",
      csGray600: "hsl(206,10%,44%)",
      csLightGrey: "hsl(0,0%,94%)",
      csDarkGrey: "hsl(0,0%,40%)",
      csLightGreen: "#c3ed44",
      csHeaderText: "#323232",
      csHeaderTextGreen: "#0A8A11",
      csBlueHighlight: "#C6DDF5",
      csLighterBlueHighlight: "#D9E9F8",
      csDarkBlue: "rgb(7,20,64)",
      csMidBlue: "#005595",
      csFocusHighlight: "#155493",
      csHoverHighlight: "#155493",
      csRoundHeader: "#06143f",
      // Generic theme tokens (the generic theme was based on ITF/WTN but should now represent the clubspark default.)
      primary200: "#001870",
      primary150: "#001e8c",
      primary100main: "#0026af",
      primary70: "#4d67c7",
      primary50: "#8092d7",
      primary30: "#b3bee7",
      primary20: "#ccd4ef",
      primary10: "#e6e9f7",
      primary5: "#f2f4fb",
      secondary200: "#0a0f1f",
      secondary150: "#0d1327",
      secondary100main: "#101831",
      secondary70: "#585d6f",
      secondary50: "#878b98",
      secondary30: "#b7bac1",
      secondary20: "#cfd1d6",
      secondary10: "#e7e8ea",
      secondary5: "#f3f3f5",
      accent1200: "#028d4a",
      accent1150: "#02b760",
      accent1100main: "#02e075",
      accent170: "#4ee99e",
      accent150: "#80efba",
      accent130: "#b4f6d6",
      accent120: "#ccf9e3",
      accent110: "#e6fcf1",
      accent15: "#f2fdf8",
      navHighlight100: "#63FFB4",
      coreGreys150: "#272f45",
      coreGreys100main: "#323950",
      coreGreys70: "#707485",
      coreGreys50: "#989ca7",
      coreGreys30: "#c2c4cb",
      coreGreys20: "#d5d7de",
      coreGreys10: "#e3e5eb",
      coreGreys5: "#f4f5f8",
      success200: "#066d62",
      success150: "#00806b",
      success100: "#169e8f",
      success70: "#5cbbb1",
      success50: "#8acec7",
      success30: "#b9e2dd",
      success20: "#d0ece9",
      success10: "#e8f5f4",
      success5: "#f3faf9",
      pending200: "#dc972f",
      pending150: "#eab565",
      pending100: "#ffd177",
      pending70: "#ffdfa0",
      pending50: "#fcdea4",
      pending30: "#fff1d6",
      pending20: "#fff6e4",
      pending10: "#fffaf1",
      pending5: "#fffdf8",
      warning200: "#873100",
      warning150: "#b44200",
      warning100: "#dc5100",
      warning70: "#e6854d",
      warning50: "#eda880",
      warning30: "#f4cbb3",
      warning20: "#f8dccc",
      warning10: "#fbeee6",
      warning5: "#fdf6f2",
      destructive200: "#ad2f3e",
      destructive150: "#c21a2d",
      destructive100main: "#d42f42",
      destructive70: "#e16d7b",
      destructive50: "#e997a0",
      destructive30: "#f2c1c6",
      destructive20: "#f6d5d9",
      destructive10: "#fbeaec",
      destructive5: "#fdf5f6",
      highlight200: "#5d20c2",
      highlight150: "#6c46d8",
      highlight100: "#6e56f2",
      highlight70: "#9989f6",
      highlight50: "#b6aaf8",
      highlight30: "#d3ccfb",
      highlight20: "#e2ddfc",
      highlight10: "#f0eefe",
      highlight5: "#f8f7fe",
      highlightTwo200: "#002e8f",
      highlightTwo100: "#004dee",
      highlightTwo50: "#80a6f6",
      highlightTwo10: "#e6edfd",
      highlightTwo5: "#f2f6fe",
      lightBg100Main: "#fff",
      lightBg70: "rgba(255, 255, 255, 0.7)",
      lightBg50: "rgba(255, 255, 255, 0.5)",
      lightBg20: "rgba(255, 255, 255, 0.2)",
      lightBg10: "rgba(255, 255, 255, 0.1)",
      lightBg5: "rgba(255, 255, 255, 0.05)",
      darkBg100Main: "#272f45",
      darkBg70: "rgba(39, 47, 69, 0.7)",
      darkBg50: "rgba(39, 47, 69, 0.5)",
      darkBg20: "rgba(39, 47, 69, 0.2)",
      darkBg10: "rgba(39, 47, 69, 0.1)",
      darkBg5: "rgba(39, 47, 69, 0.05)",
      brightGreen100: "#6fbd57",
      genericWhite: "#fff",
      genericBlack: "#000",
      coreGreys100: "#323950",
      navHighlight100Main: "#F4F6F8",
      coreGreys15020: "rgba(39, 47, 69, 0.2)",
      pendingTwo30: "rgba(221, 157, 59, 0.3)",
      wtnRed: "#dc3741",
      marineBlue: "#003a70",
      primaryActive100: "$primary100main",
      headerGradientBg: "$primary100main",
      dialogShadow: "rgba(51, 51, 51, 0.15)",
      dialogOverlay: "rgba(0, 0, 0, 0.3)"
    },
    shadows: {
      darkBgTwo120: "rgba(0, 0, 0, 0.12)",
      shadowXS: "0 1px 3px 0 rgba(20, 29, 55, 0.1)",
      shadowSM: "0 2px 4px 0 rgba(20, 29, 55, 0.08)",
      shadowMD: "0 3px 8px 0 rgba(20, 29, 55, 0.08)",
      shadowLG: "0 5px 15px 0 rgba(20, 29, 55, 0.08)",
      shadowXL: "0 7px 18px 0 rgba(20, 29, 55, 0.08)",
      shadowXXL: "0 10px 30px 0 rgba(20, 29, 55, 0.08)"
    },
    fontSizes: {
      default: "initial",
      xsmall10: "0.625rem",
      xsmall: "0.6875rem",
      small: "0.75rem",
      semiMedium: "0.8125rem",
      medium: "0.875rem",
      medium15: "0.9375rem",
      large: "1rem",
      large18: "1.125rem",
      large20: "1.25rem",
      xlarge: "1.5rem",
      xlarge32: "2rem",
      xlarge44: "2.75rem",
      xlarge56: "3.5rem"
    },
    fontWeights: {
      default: "initial",
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700
    },
    lineHeights: {
      default: "initial",
      1: 1,
      2: 1.1,
      3: 1.2,
      4: 1.3,
      5: 1.4,
      6: 1.5,
      7: 1.6
    },
    letterSpacings: {
      default: "initial"
    },
    fonts: {
      default: "'DM Sans', sans-serif",
      clubspark: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
    },
    transitions: {
      default: "250ms"
    },
    csBracket: {
      gap: "2.5rem",
      gapHalf: "calc($gap / 2)",
      lineWidth: "1px",
      radius: "0.25rem",
      lineColor: "#ccc",
      highlightLineColor: "$colors$csHiContrast"
    },
    csMatch: {
      headerHeight: "2.1rem",
      gap: "0.5rem",
      radius: "0.375rem",
      borderColor: "#e4e4e4"
    },
    space: {
      xxs: "2px",
      xs: "4px",
      sm: "5px",
      md: "12px",
      lg: "20px",
      xl: "25px"
    },
    radii: {
      none: 0,
      xs: "0.125rem",
      sm: "0.25rem",
      md: "0.5rem",
      lg: "1rem",
      xl: "2rem",
      circle: "50%"
    }
  }
}, {
  config: n,
  createTheme: a,
  css: d,
  keyframes: g,
  theme: h,
  globalCss: f,
  getCssText: l
} = r(e), m = a("light-theme"), o = a("clubspark-light-theme", {
  ...e.theme,
  fonts: {
    ...e.theme.fonts,
    default: e.theme.fonts.clubspark
  }
}), p = a("dark-theme", {
  colors: {
    csHiContrast: "hsl(206,2%,93%)",
    csLoContrast: "hsl(206,8%,8%)",
    csBackground: "#333",
    csGray100: "hsl(206,8%,12%)",
    csGray200: "hsl(206,7%,14%)",
    csGray300: "hsl(206,7%,15%)",
    csGray400: "hsl(206,7%,24%)",
    csGray500: "hsl(206,7%,30%)",
    csGray600: "hsl(206,5%,53%)",
    csLightGrey: "hsl(206,7%,15%)",
    csDarkGrey: "hsl(206,5%,53%)",
    csHeaderBg: "#323232",
    csHeaderText: "#f4f4f4",
    csBlueHighlight: "#287CAD",
    csLighterBlueHighlight: "#004c64"
  },
  csBracket: {
    lineColor: "#1f1f1f",
    highlightLineColor: "$colors$csHiContrast"
  },
  csMatch: {
    borderColor: "#1f1f1f"
  },
  space: {},
  fonts: {}
}), c = {
  ...e.theme,
  colors: {
    primary200: "#004CA3",
    primary150: "#025CC2",
    primary100main: "#0367DB",
    primary70: "#0373F3",
    primary50: "#5BA4F7",
    primary30: "#B3D5FB",
    primary20: "#CCE3FC",
    primary10: "#E6F1FE",
    primary5: "#F2F8FE",
    secondary200: "#000A20",
    secondary150: "#0A173E",
    secondary100main: "#00143F",
    secondary70: "#5C6582",
    secondary50: "#8A91A5",
    secondary30: "#B9BDC9",
    secondary20: "#D0D3DB",
    secondary10: "#E8E9ED",
    secondary5: "#F3F4F6",
    accent1200: "#C15642",
    accent1150: "#E08E41",
    accent1100main: "#F0AA54",
    accent170: "#F4C387",
    accent150: "#F7D4A9",
    accent130: "#FAE5CC",
    accent120: "#FCEEDD",
    accent110: "#FDF6EE",
    accent15: "#FEFBF6",
    primaryActive100: "$primary100main",
    headerGradientBg: "$primary100main"
  },
  fonts: {
    default: "Inter, sans-serif"
  },
  radii: {
    sm: "5px"
  }
}, y = a("usta-light-theme", c), s = {
  colors: {
    primary200: "#002950",
    primary150: "#004586",
    primary100main: "#0054a3",
    primary70: "#4d87be",
    primary50: "#80a9d0",
    primary30: "#b3cce3",
    primary20: "#ccdded",
    primary10: "#e6eef6",
    primary5: "#f2f6fa",
    accent1200: "#8b050d",
    accent1150: "#bf222c",
    accent1100main: "#dc3741",
    accent170: "#e6737a",
    accent150: "#ed9ba0",
    accent130: "#f4c3c6",
    accent120: "#f8d7d9",
    accent110: "#fbebec",
    accent15: "#fdf5f6",
    navHighlight100: "#5ec5ff",
    primaryActive100: "$wtnRed",
    headerGradientBg: "linear-gradient(268.69deg, $wtnRed -14.8%, $marineBlue 112.85%)"
  },
  fonts: {
    default: "Poppins, sans-serif"
  }
}, x = a("itf-light-theme", s);
export {
  o as clubsparkLightTheme,
  n as config,
  a as createTheme,
  d as css,
  p as darkTheme,
  l as getCssText,
  f as globalCss,
  x as itfLightTheme,
  s as itfLightThemeConfig,
  g as keyframes,
  m as lightTheme,
  h as theme,
  y as ustaLightTheme,
  c as ustaLightThemeConfig
};
//# sourceMappingURL=stitches.config.es.js.map
